import gql from 'graphql-tag';
import { SETUP_INSTRUCTION_CONTROL_PHOTOS_FRAGMENT, SETUP_INSTRUCTION_FRAGMENT } from './setupInstruction';

export const FREEFOOD_SETUP_FRAGMENT = gql`
    fragment FreefoodSetupFragment on FreefoodSetup {
        _id
        createdAt
        isNeeded
        instructions {
            ...SetupInstructionFragment
        }
        state
        updatedAt
    }
    ${SETUP_INSTRUCTION_FRAGMENT}
`;

export const FREEFOOD_SETUP_CONTROL_PHOTOS_FRAGMENT = gql`
    fragment FreefoodSetupControlPhotosFragment on FreefoodSetup {
        instructions {
            ...SetupInstructionControlPhotosFragment
        }
    }
    ${SETUP_INSTRUCTION_CONTROL_PHOTOS_FRAGMENT}
`;
